//тип решение при голосовании
export enum ParticipantVoteType {
    No = 0,
    Yes = 1,
}
